import React from 'react';

import * as _Image from './Image.jsx';

// #region IMAGE

function Image(props) {
    let data = props.itemData || props.data || {};
    if (data.Inventory && props.index < data.Inventory.length) {
        data = data.Inventory[props.index];
    }
    return <_Image.Component {...props} alt={data.Title} image={data.Image} imageUrl={data.ImageUrl} url={data.Url} />
}
const TypeConfig = _Image.TypeConfig;

// #endregion IMAGE

export {
    Image as Component,
    TypeConfig
}